import { render } from "./HomeProjects.vue?vue&type=template&id=1ebf8736&scoped=true"
import script from "./HomeProjects.vue?vue&type=script&lang=js"
export * from "./HomeProjects.vue?vue&type=script&lang=js"

import "./HomeProjects.vue?vue&type=style&index=0&id=1ebf8736&scoped=true&lang=css"

import exportComponent from "/home/runner/work/arc-studio-front/arc-studio-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ebf8736"]])

export default __exports__